import type { DeliveryMethodDto } from '../../generated-api';
import { DeliveryMethodDtoTypeEnum } from '../../generated-api';
import { useLocation } from '../context/LocationContext';

const useDeliveryFee = (deliveryMethod: DeliveryMethodDto, tableNumber?: string) => {
  const { location } = useLocation();
  const tableDeliveryMethod = location.deliveryMethods.find((d) => d.type === DeliveryMethodDtoTypeEnum.TABLE);

  if (tableNumber) {
    return tableDeliveryMethod?.feeAmount || 0;
  }

  return deliveryMethod?.feeAmount || 0;
};

export default useDeliveryFee;
